import type { PortfolioAnalyticsPropertyDto } from '@zg-rentals/ts-customer-analytics-client';

export const formatAddress = (property: PortfolioAnalyticsPropertyDto) => {
  return `${property.street}, ${property.city}, ${property.state} ${property.zip}`;
};
